var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import axios from "axios";
import { html } from "lit";
import isEqual from "lodash-es/isEqual.js";
import { dataToObject, apiHost } from "./utils.js";
import { when } from "lit/directives/when.js";
import "../common/loading-animation.js";

var QuoteController = /*#__PURE__*/function () {
  function QuoteController(host, onChange) {
    _classCallCheck(this, QuoteController);

    this.status = 0;
    (this.host = host).addController(this);
    this.onChange = onChange;
  }

  _createClass(QuoteController, [{
    key: "hostUpdate",
    value: function () {
      var _hostUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var datasetObj;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                datasetObj = dataToObject(this.host.dataset);

                if (!(!isEqual(this.host.policyAttributes, {}) && this.host.clientId !== void 0 && (!isEqual(this.host.policyAttributes, this.policyAttributes) || !isEqual(this.host.customer, this.customer) || !isEqual(datasetObj, this.metadata)))) {
                  _context.next = 5;
                  break;
                }

                this.metadata = datasetObj;
                _context.next = 5;
                return this.loadQuote();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function hostUpdate() {
        return _hostUpdate.apply(this, arguments);
      }

      return hostUpdate;
    }()
  }, {
    key: "loadQuote",
    value: function () {
      var _loadQuote = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _a, _b, requestBody, response, responseError, data, status;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.status = 0;
                this.policyAttributes = this.host.policyAttributes;
                this.customer = this.host.customer;
                requestBody = {
                  customer: this.customer,
                  policy_attributes: this.policyAttributes
                };

                if (this.host.quoteId) {
                  requestBody["quote_id"] = this.host.quoteId;
                }

                if (this.host.offerId) {
                  requestBody["offer_id"] = this.host.offerId;
                }

                if (this.metadata) {
                  requestBody["metadata"] = this.metadata;
                }

                _context2.prev = 7;
                _context2.next = 10;
                return axios.post("".concat(apiHost, "/v1/quote/").concat(this.host.product), requestBody, {
                  headers: {
                    "Content-Type": "application/json",
                    "x-api-client-id": this.host.clientId,
                    "x-api-source": "Web Component",
                    "x-api-web-component-version": "4.4.1"
                  }
                });

              case 10:
                response = _context2.sent;
                this.status = 1;
                this.value = response.data;
                this.host.quoteId = response.data.quote_id;

                if (response.data.offer_id) {
                  this.host.offerId = response.data.offer_id;
                }

                this.onChange();
                _context2.next = 32;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](7);
                this.status = 2;
                responseError = _context2.t0;
                data = (_a = responseError.response) == null ? void 0 : _a.data;
                status = (_b = responseError.response) == null ? void 0 : _b.status;

                if (!(status === 422)) {
                  _context2.next = 31;
                  break;
                }

                this.host.unsetOfferId();
                this.host.unsetQuoteId();
                _context2.next = 29;
                return this.loadQuote();

              case 29:
                _context2.next = 32;
                break;

              case 31:
                if (status === 400) {
                  if (!data._embedded) {
                    this.error = new Error(data.message, {
                      cause: data.error
                    });
                    this.host.dispatchEvent(new CustomEvent("quote-error"));
                  } else {
                    if (this.host.debug) {
                      console.debug("Failed to retrieve quote", data._embedded);
                    }
                  }
                }

              case 32:
                this.host.requestUpdate();

              case 33:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 18]]);
      }));

      function loadQuote() {
        return _loadQuote.apply(this, arguments);
      }

      return loadQuote;
    }()
  }, {
    key: "render",
    value: function render(renderer) {
      return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <div id=\"offer-wrapper\">\n        ", "\n        ", "\n      </div>\n    "])), when(this.status === 0 && this.value != void 0, function () {
        return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          <loading-animation></loading-animation>\n        "])));
      }), this._pendingRenderWrapper(renderer));
    }
  }, {
    key: "_pendingRenderWrapper",
    value: function _pendingRenderWrapper(renderer) {
      var _a, _b, _c;

      if (this.status === 2) {
        return (_a = renderer.error) == null ? void 0 : _a.call(renderer, this.error);
      } else if (this.status === 0 && this.value == void 0) {
        return (_b = renderer.pending) == null ? void 0 : _b.call(renderer);
      } else {
        return (_c = renderer.complete) == null ? void 0 : _c.call(renderer, this.value);
      }
    }
  }]);

  return QuoteController;
}();

export { QuoteController };